export default __webpack_public_path__ + "static/media/745.0eafd3cf.png";